import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import dashboardSlice from "../features/date/dashboardSlice";
import addManagerSlice from "../features/addManager/addManagerSlice";
import toastslice from "../features/Toaster/toastslice";
import settingSlice from "../features/settingSlice/settingSlice";
import settingSyncReducer from "../features/settingSync/settingsyncSlice";
import reportslice from "../features/reports/reportslice";
import employeeListSlice from "../features/employee/employeeListSlice";
import employeePerformanceSlice from "../features/employee/employeePerformanceSlice";

const rootReducer = combineReducers({
  filterData: dashboardSlice,
  addManager: addManagerSlice,
  toast: toastslice,
  setting: settingSlice,
  settingSync: settingSyncReducer,
  report: reportslice,
  employeeList: employeeListSlice,
  employeePerformance: employeePerformanceSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "filterData",
    "report",
    "employeeList",
    "employeePerformance",
    "setting",
  ], // persist only these slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

// const store = configureStore({
//   reducer: {
//     filterData: dashboardSlice,
//     addManager: addManagerSlice,
//     toast: toastslice,
//     setting: settingSlice,
//     settingSync: settingSyncReducer,
//   },
// });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
